<template>
    <header class="htpall">
        <div class="htpcon">
            <!--標頭Logo-->
            <h1 class="htplogo">
                <a href="/">
                    <img src="images/mainLogo.svg" alt="臺灣大學生物產業傳播暨發展學系" />
                </a>
            </h1>
            <div class="htpright">
                <!--標題列右側功能列表-->
                <!--網站導覽文字列表-->
                <div class="tplink">
                    <!--網站導覽-->
                    <a href="/Sitemap">網站導覽</a>
                    |
                    <!--台大網站-->
                    <a href="https://www.ntu.edu.tw/" target="_blank" title="臺大官網(另開新視窗)">臺大首頁</a>
                </div>
                <!--全站查詢欄-->
                <div class="searchall">
                    <input class="seahbox" v-model="searchKeyWords" 
                          v-on:keyup.enter="search" placeholder="全站搜尋" ></input>
                    <div class="seahbtn" >
                        <!--搜尋按鈕-->
                        <a href="javascript:void(0)" @click="search()" title="開始查詢" role="button">
                            <img src="images/search.png" alt="搜尋"/>
                        </a>
                    </div>
                </div>
                <!--語系切換-->
                <div class="langall">
                    <!-- TODO 動態寫入目前語系 & 判斷下拉選單目前語系並套用Class-->
                    中文
                    <div class="lanselb">
                        <!--當前語系套用aclang這個class-->
                        <div class="lanbx">
                            <a class="aclang">中文</a>
                        </div>
                        <div class="lanbx">
                            <a @click="gotoEN()">English</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>
<script>

export default{

    data(){
        return {
            //
            searchKeyWords:"",
            //
            rwd:{
                type:0,
            },
            //標題名稱
            title:"",
        };
    },
    props:["header"],
    mounted(){
        //初始化
        this.init();
        
    },
    watch:{
        header(){
           document.title = this.header.text1 +(this.header.text2?'-'+this.header.text2:"") + (this.header.text3?"-"+this.header.text3:"");
        }
    },
    methods:{
        //初始化
        init(){
            document.body.className='';
            document.body.classList.add("mbkcolor");
            //2025-11-14 移除全站查詢bootstrape 預設樣式
            $('#textfield').removeClass('form-control');

           document.title = this.header.text1 +(this.header.text2?'-'+this.header.text2:"") + (this.header.text3?"-"+this.header.text3:"");
        },
        //查詢功能
        search(){
            this.functionSearch(this.searchKeyWords);
        },
        //查詢功能
        functionSearch(data){
            if(data==''){
                alert('請輸入關鍵字');
            }else{
                //TODO 前往全站搜尋頁面
                this._go1("/Search?q="+encodeURIComponent(data));
            }
        },
        //前往當前頁面英文版
        gotoEN(){
            this.$router.push({
                path: "/EN" +this.$route.path,
                query:this.$route.query,
            });
        },
    },
};
</script>